import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  connect() {
    // Auto-dismiss success messages after 5 seconds
    this.messageTargets.forEach((message, index) => {
      if (message.classList.contains('bg-green-50')) {
        setTimeout(() => {
          this.dismissMessage(message)
        }, 5000 + (index * 500)) // Stagger multiple messages
      }
    })
  }

  dismiss(event) {
    const message = event.currentTarget.closest('[data-flash-messages-target="message"]')
    if (message) {
      this.dismissMessage(message)
    }
  }

  dismissMessage(message) {
    // Add exit animation
    message.style.transform = 'translateX(100%)'
    message.style.opacity = '0'
    
    // Remove element after animation completes
    setTimeout(() => {
      if (message.parentElement) {
        message.remove()
      }
    }, 300)
  }
}